<div class="cc-backdrop" aria-modal="true" role="dialog" [attr.aria-label]="'cookies.title' | transloco">

  <!-- Bottom sheet -->
  <div class="cc-sheet" [class.cc-sheet--prefs]="view() === 'preferences'">

    <!-- Floating cookie icon — only on main view -->
    @if (view() === 'main') {
      <div class="cc-icon-wrap" aria-hidden="true">
        <img src="/icons/cookie.svg" width="40" height="40" alt="" />
      </div>
    }

    <!-- Yellow glow blobs — clipped so blur doesn't leak outside the sheet -->
    <div class="cc-glow-clip" aria-hidden="true">
      <div class="cc-glow cc-glow--right"></div>
      <div class="cc-glow cc-glow--left"></div>
    </div>

    <!-- ── MAIN VIEW ── -->
    @if (view() === 'main') {

      <!-- Close button -->
      <button
        type="button"
        class="cc-close"
        (click)="declineAll()"
        [attr.aria-label]="'common.cancel' | transloco"
      >
        <lumio-icon name="x" [size]="24" />
      </button>

      <div class="cc-content">
        <div class="cc-text">
          <h2 class="cc-title">{{ 'cookies.title' | transloco }}</h2>
          <p class="cc-desc">{{ 'cookies.desc' | transloco }}</p>
        </div>

        <div class="cc-actions">
          <button type="button" class="cc-btn cc-btn--primary" (click)="acceptAll()">
            {{ 'cookies.acceptAll' | transloco }}
          </button>

          <button type="button" class="cc-btn cc-btn--outlined" (click)="declineAll()">
            {{ 'cookies.declineAll' | transloco }}
          </button>

          <button type="button" class="cc-link" (click)="openPreferences()">
            {{ 'cookies.managePreferences' | transloco }}
          </button>
        </div>
      </div>

    }

    <!-- ── PREFERENCES VIEW ── -->
    @if (view() === 'preferences') {

      <!-- Back button + title -->
      <div class="cc-prefs-topbar">
        <button
          type="button"
          class="cc-prefs-back"
          (click)="goBack()"
          [attr.aria-label]="'common.back' | transloco"
        >
          <lumio-icon name="chevron-left" [size]="22" />
        </button>
        <span class="cc-prefs-title">{{ 'cookies.managePreferences' | transloco }}</span>
      </div>

      <!-- Categories -->
      <div class="cc-prefs-list">

        <!-- Essential (always on) -->
        <div class="cc-prefs-row">
          <div class="cc-prefs-info">
            <span class="cc-prefs-name">{{ 'cookies.prefs.essential' | transloco }}</span>
            <span class="cc-prefs-desc">{{ 'cookies.prefs.essentialDesc' | transloco }}</span>
          </div>
          <span class="cc-prefs-always">{{ 'cookies.prefs.alwaysOn' | transloco }}</span>
        </div>

        <!-- Analytics -->
        <div class="cc-prefs-row">
          <div class="cc-prefs-info">
            <span class="cc-prefs-name">{{ 'cookies.prefs.analytics' | transloco }}</span>
            <span class="cc-prefs-desc">{{ 'cookies.prefs.analyticsDesc' | transloco }}</span>
          </div>
          <button
            type="button"
            class="cc-toggle"
            [class.cc-toggle--on]="analyticsEnabled()"
            (click)="toggleAnalytics()"
            [attr.aria-checked]="analyticsEnabled()"
            role="switch"
          ></button>
        </div>

        <!-- Marketing -->
        <div class="cc-prefs-row">
          <div class="cc-prefs-info">
            <span class="cc-prefs-name">{{ 'cookies.prefs.marketing' | transloco }}</span>
            <span class="cc-prefs-desc">{{ 'cookies.prefs.marketingDesc' | transloco }}</span>
          </div>
          <button
            type="button"
            class="cc-toggle"
            [class.cc-toggle--on]="marketingEnabled()"
            (click)="toggleMarketing()"
            [attr.aria-checked]="marketingEnabled()"
            role="switch"
          ></button>
        </div>

      </div>

      <!-- Save button -->
      <div class="cc-prefs-footer">
        <button type="button" class="cc-btn cc-btn--primary cc-btn--full" (click)="savePreferences()">
          {{ 'cookies.prefs.save' | transloco }}
        </button>
      </div>

    }

  </div>

</div>
